import api from './api';
import types from './mutation-types';

import { convertNvl } from '@/qmsUtils/'; //공통함수 import

export default {
	/**call API */
	async getCommCodes_({ commit }, { key, codeType }) {
		try {
			const { header, body } = await api.getCommCodes(codeType);

			if (header.code === 0) {
				await commit(types.DEFAULT_ASSIGN, { key, value: body });
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			return error.header || error;
		}
	},
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, {
			key: key,
			value: value !== null && value !== undefined ? value : null
		});
	},
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	setStateApcnInit_({ commit }) {
		commit(types.STATE_APCN_INIT);
	},
	setPagingInfo_({ commit }, { key, value }) {
		commit(types.PAGING_INFO, { key, value });
	},
	setState_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
	},
	setStateClamSave_({ commit }, { key, value }) {
		commit(types.CLAM_SAVE_INFO, { key, value });
	},
	setStateMkObjPopUp_({ commit }, { key, value }) {
		commit(types.APCN_INFO, { key, value });
	},
	setBtnApprAuth_({ commit, state }) {
		//승인,기각,반려,권한
		let prcsStep = state.mkObjPopUp.prcsStepObj || '';

		let result = false;

		//console.log('승인기각 화면권한은 있음>>>>>', prcsStep);
		if (prcsStep == '20') {
			//console.log('신청일경우에는 승인,기각,반려 할수있다.');
			result = true;
		} else {
			//신청상태가 아니면 승인 기각 반려를 할수가 없다.
			//console.log('신청상태가 아니면 승인 기각 반려를 할수가 없다.');
			result = false;
		}

		commit(types.APCN_INFO, {
			key: 'btnApprAuth',
			value: result
		});
	},
	setBtnDelAuth_({ commit, state }, paramAuth) {
		//
		//신청버튼 권한
		let prcsStep = state.mkObjPopUp.prcsStepObj || '';
		let aplcDd = state.mkObjPopUp.aplcDdObj || '';
		let prcsRslt = state.mkObjPopUp.prcsRsltObj || '';
		let result = false;

		if (paramAuth) {
			//console.log('삭제화면권한은 있음');
			if (prcsStep == '10') {
				//console.log('처음 PWA생성하거나 임시저장일경우');
				result = true;
			} else {
				//console.log('임시저장일경우에만 삭제가 가능하다.');
				result = false;
			}
		} else {
			//console.log('화면권한은 없음');
			result = false;
		}

		commit(types.APCN_INFO, {
			key: 'btnDelAuth',
			value: result
		});
	},
	setBtnApAuth_({ commit, state }, paramAuth) {
		//setDelAuth_
		//신청버튼 권한
		let prcsStep = state.mkObjPopUp.prcsStepObj || '';
		let aplcDd = state.mkObjPopUp.aplcDdObj || '';
		let prcsRslt = state.mkObjPopUp.prcsRsltObj || '';
		let result = false;

		if (paramAuth) {
			//console.log('화면권한은 있음', prcsStep);
			if (prcsStep == '' || prcsStep == '10') {
				//console.log('처음 PWA생성하거나 임시저장일경우 신청버튼을 노출시킨다.');
				result = true;
			} else {
				//처리단계가 신청이며 아니며  처리결과가 공백이 아닐경우 없을경우 임시저장 버튼을 감춘다.
				if (prcsStep != '20' && aplcDd != '') {
					//console.log('처리단계가 신청단계며  신청일자가 있을경우 신청버튼을 버튼을 감춘다.');
					result = false;
				}
			}
		} else {
			//console.log('화면권한은 없음');
			result = false;
		}

		commit(types.APCN_INFO, {
			key: 'btnApAuth',
			value: result
		});
	},
	setBtnTsAuth_({ commit, state }, paramAuth) {
		//임시저장버튼 권한설정
		let prcsStep = state.mkObjPopUp.prcsStepObj || '';
		let aplcDd = state.mkObjPopUp.aplcDdObj || '';
		let prcsRslt = state.mkObjPopUp.prcsRsltObj || '';
		let result = false;

		if (paramAuth) {
			//('화면권한은 있음');
			if (prcsRslt == '10') {
				//console.log('처리결과가 확정이면 재의뢰를 해야됨으로 초기화버튼이 필요함');
				result = true;
			} else {
				//처리단계가 임시저장이 아니며  처리결과가 공백이 아닐경우 없을경우 임시저장 버튼을 감춘다.
				if (prcsStep == '' || prcsStep != '10') {
					//console.log('처리단계가 확정이 아니거나  처리단계가 공백일경우 초기화 버튼을 감춘다.');
					result = false;
				}
			}
		} else {
			//console.log('화면권한은 없음');
			result = false;
		}

		commit(types.APCN_INFO, {
			key: 'btnTsAuth',
			value: result
		});
	},
	getMkObjList_({ commit, state }) {
		//협력사 이의제기 목록조회
		//actions,getters,mutaions는 첫번째 인자로 store안에,commit,state,dispatch

		const { searchParams, pagingInfo } = state;

		return api
			.getMkObjList({ searchParams: searchParams, currentPage: pagingInfo.currentPage, pageUnit: pagingInfo.pageUnit })
			.then(data => {
				if (data.header.code === 0) {
					//console.log('데이터 클레임 조회 값은뭐냐>>>>>', data.body);

					commit(types.DEFAULT_ASSIGN, {
						key: 'mkObjList',
						value: data?.body.resultList || []
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'pagingInfo',
						value: data?.body.pagingInfo
					});
					/*
					commit(types.DEFAULT_ASSIGN, {
						key: 'excelDownLoadList',
						value: data?.body.selectSamPleExcelList || []
					});
					*/
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	async getClamNoPopList_({ commit, state }, clamNoParam) {
		// 클레임 신청팝업조회
		//actions,getters,mutaions는 첫번째 인자로 store안에,commit,state,dispatch

		return await api
			.getClamNoPopList(clamNoParam.clmNo)
			.then(data => {
				if (data.header.code === 0) {
					//console.log('데이터 클레임 조회 값은뭐냐>>>>>', data.body);

					commit(types.DEFAULT_ASSIGN, {
						key: 'mkObjPopUp',
						value: data?.body.resultVo || {}
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'mkObjSwapPartsList',
						value: data?.body.resultList || []
					});

					commit(types.DEFAULT_ASSIGN, {
						key: 'fileList',
						value: data?.body.fileList || []
					});

					/*컴포넌트 READONLY 처리 */
					commit(types.APCN_INFO, {
						key: 'readOnlyAuth',
						value: data.body.resultVo.prcsStepObj == '20' || data.body.resultVo.prcsStepObj == '30' ? true : false
					});

					//콤포넌트 커밋
					commit(types.APCN_INFO, {
						key: 'readOnlyAuth1',
						value: data.body.resultVo.prcsStepObj == '20' || data.body.resultVo.prcsStepObj == '30' ? true : false
					});

					commit(types.APCN_INFO, {
						key: 'mkobType',
						value: data.body.resultVo.cmpnNo != null ? '20' : convertNvl(data.body.resultVo.mkobType, '')
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	}, //실제 파일명을 클릭했을때 다운로드 하기 위한 함수
	async fileDownload_(store, params = { fileId, fileSeq }) {
		try {
			const response = await api.fileDownload({ params });
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = url;
			const filename = decodeURIComponent(response.headers.filename);
			link.setAttribute('download', filename);
			document.body.appendChild(link);
			link.click();
			link.remove();
			window.URL.revokeObjectURL(url);
		} catch (error) {
			return error.header || error;
		}
	},
	saveMkObjPopup_({ commit }, { formData }) {
		/*fromData 찍어보기*/
		return api
			.saveMkObjPopup({ formData })
			.then(data => {
				if (data.header.code === 0) {
					return data;
				} else {
					throw new Error(data.header.message);
					// throw new Error(data.header.messageCd);
				}
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	saveStateAppr_({ commit, state }, payload) {
		//param,
		return api
			.saveStateAppr(state)
			.then(data => {
				//console.log('data 값은>>', data);
				if (data.header.code === 0) {
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	setPopupSearchParam_({ commit }, { key, value }) {
		commit(types.POPUP_SEARCH_PARAM, {
			key: key,
			value: value !== null && value !== undefined ? value : null
		});
	},
	async getCalAplRpymAmt1_({ commit, state }, param) {
		// 클레임 신청팝업조회
		//actions,getters,mutaions는 첫번째 인자로 store안에,commit,state,dispatch

		return await api
			.getCalAplRpymAmt(param)
			.then(data => {
				//console.log('data가없나', data);

				if (data.header.code === 0) {
					//console.log('데이터 클레임 조회 값은뭐냐>>>>>', data.body);

					commit(types.APCN_INFO, {
						key: 'bflRpymAmt2',
						value: data?.body.result.bflRpymAmt2 || {}
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	async getCalAplRpymAmt2_({ commit, state }, param) {
		// 클레임 신청팝업조회
		//actions,getters,mutaions는 첫번째 인자로 store안에,commit,state,dispatch

		return await api
			.getCalAplRpymAmt(param)
			.then(data => {
				//console.log('data가없나', data);

				if (data.header.code === 0) {
					//console.log('데이터 클레임 조회 값은뭐냐>>>>>', data.body);

					commit(types.APCN_INFO, {
						key: 'aplRpymAmt2',
						value: data?.body.result.aplRpymAmt2 || {}
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	}
};
